import { Box, Grid } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

const Root = ({ children }: PropsWithChildren) => {
	return (
		<Box h="100vh" overflow="hidden" w="100%">
			<Box border="1px solid {colors.gray.50}" h="100%" maxW="1920px" mx="auto">
				<Grid h="100%" templateColumns="auto 1fr">
					{children}
				</Grid>
			</Box>
		</Box>
	);
};

const Sidebar = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<Box
			borderRight="1px solid {colors.gray.50}"
			maxW="300px"
			minW={0}
			overflowX="hidden"
			overflowY="auto"
			scrollbar="hidden"
			w="fit-content"
			{...props}
		>
			{children}
		</Box>
	);
};

const Content = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<Box
			bg="white"
			h="100%"
			minH={0}
			minW={0}
			{...props}
		>
			{children}
		</Box>
	);
};

export const DashboardShell = {
	Content,
	Root,
	Sidebar,
};
